import { AccountingWorkpadsDraftsService } from '@festina/life-general-types/life/services/AccountingWorkpadsDraftsService'
import { useFestinaMutation } from '@festina-life/authentication'

const method =
  AccountingWorkpadsDraftsService.workPadsDraftsServicePostApproveDraftWorkPad
type MethodParam = Omit<Parameters<typeof method>[0], `x${string}`>

type Props = {
  tenantId: string
}

export const useApproveDraftWorkPad = ({ tenantId }: Props) =>
  useFestinaMutation({
    component: 'life',
    roles:
      AccountingWorkpadsDraftsService.workPadsDraftsServicePostApproveDraftWorkPad_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({
        xTenantId: tenantId,
        ...arg,
      })
    },
  })
